<template>
    <vs-card>
        <div slot="header">
          <h4 class="font-weight-bold card-title d-flex">
            {{$t('ACCOUNTING.ACC_SUM.HEADER')}} ({{CurrencyAsText(sum_brutto)}})
          </h4>

        </div>
        <div class="d-flex">
          <vs-list >
            <vs-list-item :title="$t('ACCOUNTING.ACC_SUM.GESAMT')" :subtitle="$t('ACCOUNTING.ACC_SUM.EXKL')"><vs-chip>{{sum_netto_txt}}</vs-chip></vs-list-item>
            <template v-for="(mwst,index) in sum_mwst">
              <vs-list-item :key="'mwst_'+index" :title="$t('ACCOUNTING.ACC_SUM.DAVON')" :subtitle="$t('ACCOUNTING.ACC_SUM.MWST1')+' '+mwst.mwst_val+$t('ACCOUNTING.ACC_SUM.MWST2')"><vs-chip>{{CurrencyAsText(mwst.betr)}}</vs-chip></vs-list-item>
            </template>
            <vs-list-item :title="$t('ACCOUNTING.ACC_SUM.GESAMT')" :subtitle="$t('ACCOUNTING.ACC_SUM.INKL')"><vs-chip color="primary" class="font-size-120p">{{sum_brutto_txt}}</vs-chip></vs-list-item>
          </vs-list>
          
        </div>
      </vs-card>
</template>
<script>

import helperMethods from '../../helper/staticFuncHelper';
import codeHelper from '../../helper/staticCodeHelper';
import enumHelper from '../../helper/enumHelper';

export default {
  name: "AccountingMemberSum",
  props:[],
  data: function (){
     return {
      members:[],
      sum_mwst:[],
      sum_netto:0,
      sum_brutto:0
     }
  }, 
  mounted () {
  },
  methods:{
    ...helperMethods,
    ...codeHelper,
    ...enumHelper,
    SetMembers(mem){
      this.members = [];
      this.members = mem;
    },
    addMwstVal(member){
      var found = false;
      if(member.mwst_val != 0)
      {
        for(var i = 0; i < this.sum_mwst.length; i++)
        {
          if(this.sum_mwst[i].mwst_val == member.mwst_val)
          {
            found = true;

            let mwst_betrag = (member.brutto - member.netto) * member.amount;
            let partnerdiscount = 0;
            
            if(this.IsNotNull(member.partnerdiscount_brutto) && this.IsNotNull(member.partnerdiscount_netto))
            {
              partnerdiscount = (member.partnerdiscount_brutto - member.partnerdiscount_netto) * member.amount;
            }

            this.sum_mwst[i].betr += (mwst_betrag - partnerdiscount);
            break;
          }
        }
        if(found == false)
        {
          var mem = {mwst_val:member.mwst_val,betr: (member.brutto - member.netto) * member.amount};
          this.sum_mwst.push(mem);
        }
      }
    },
    CurrencyAsText(betr)
    {
      return this.DecimalToString(betr,this.currency_kuerzel,this.GetLocalFormatOfLanguage(this.language_fk));
    },
    CalcSum(){
      this.sum_mwst = [];
      this.sum_netto = 0;
      this.sum_brutto = 0;

      if(this.IsNotNull(this.members))
      {
        let mwstGroups = Map.groupBy(this.members, member => {
          return member.mwst_val;
        });

        for (let [key, value] of mwstGroups) {
          let mwst = 0;
          let textonly = false;

            value.forEach(mem => {
                this.sum_netto += mem.fullNettoSum;
                this.sum_brutto += mem.fullBruttoSum;
                mwst += mem.fullBruttoSum - mem.fullNettoSum;
                textonly = mem.text_only;
            });
            if (textonly == false)
            {
              let tmp = {mwst_val:key, betr: mwst};
              this.sum_mwst.push(tmp);
            }
        }

      }
      
    }
  },
  computed:{

    sum_netto_txt(){
      return this.CurrencyAsText(this.sum_netto);
    },
    sum_brutto_txt(){
      return this.CurrencyAsText(this.sum_brutto);
    },
    currency_kuerzel(){
      var retVal = 'EUR';

      if(this.members.length > 0)
      {
        retVal = this.members[0].currency_kuerzel;
      }

      return retVal;
    },
    language_fk(){
      var retVal = 1;
      if(this.members.length > 0)
      {
        retVal = this.members[0].language_fk;
      }      
      return retVal;
    }
  },
  watch:{
    members(){
      this.CalcSum();
    }
  }
};
</script>